module.exports = __webpack_public_path__ + "media/images/about/yg_2-0a734592355764050be1e5974cf1662f.jpg";